{
  "common": {
    "show": "Mostrar",
    "about": "Acerca de",
    "newPost": "Nueva publicación",
    "active": "Activo",
    "change": "Cambio",
    "remove": "Eliminar",
    "cancel": "Cancelar",
    "publish": "Publicar",
    "save": "Guardar",
    "draft": "Borrador",
    "scheduled": "Programado",
    "published": "Publicado",
    "actions": "Acciones",
    "archive": "Archivar",
    "delete": "Borrar",
    "edit": "Editar",
    "edited": "Editado",
    "settings": "Configuración",
    "signUp": "Registrarse",
    "by": "Por",
    "for": "para",
    "you": "Usted",
    "one": "uno",
    "option": "Opción ",
    "registered": "Registrado",
    "to": "a",
    "allEvents": "Todos los eventos",
    "placeholder": "marcador de posición",
    "percentOf": "% de",
    "private": "Privado",
    "updatedOn": "Actualizado el",
    "blogPost": "Publicación de blog",
    "category": "Categoría",
    "author": "Autor",
    "status": "Estado",
    "errors": {
      "label": "Errores",
      "SOMETHING_WENT_WRONG": "Se ha producido un error. Inténtelo de nuevo más tarde."
    },
    "all": "Todo",
    "archived": " Archivado",
    "back": "Atrás",
    "restore": "Restaurar esta versión",
    "next": "Siguiente",
    "previous": "Anterior",
    "continue": "Continuar",
    "continueButton": "Continuar",
    "paid": "Pagado",
    "free": "Gratis",
    "uploadImagesVideos": "Subir imágenes/vídeos",
    "upload": "Subir",
    "add": "Añadir",
    "on": "Activado",
    "from": "de",
    "members": "miembros",
    "visibility": "Visibilidad",
    "public": "Público",
    "description": "Descripción",
    "managedBy": "Gestionado por",
    "noManagers": "Sin gerentes",
    "noDescription": "Sin descripción",
    "more": "Más",
    "moreCaps": "Más",
    "less": "menos",
    "and": "y",
    "in": "en",
    "allSet": "¡Todo listo!",
    "createdBy": "Creado por",
    "home": "Inicio",
    "selected": "Seleccionado",
    "groupMembers": "Miembros del grupo",
    "everyone": "Todos",
    "manager": "Gestor",
    "leave": "Abandonar",
    "membersList": "Lista de miembros",
    "findChannelManagers": "Encontrar administradores de canales",
    "searchGroupMembers": "Buscar Miembros del Grupo",
    "searchMembers": "Buscar miembros",
    "searchMember": "Buscar miembro",
    "enterDescription": "Introduzca la descripción",
    "apply": "Aplicar",
    "selectRole": "Seleccione el rol",
    "people": "Personas",
    "viewProfile": "Ver perfil",
    "leaderboard": "Tabla de clasificación",
    "events": "Eventos",
    "logOut": "Cerrar sesión",
    "topLevelReached": "Nivel superior alcanzado",
    "topLevelReachedExclaim": "¡Nivel superior alcanzado!",
    "congratsTopLevel": "¡Enhorabuena! ¡Ha alcanzado el nivel superior!",
    "share": "Compartir",
    "copyLink": "Copiar enlace",
    "reply": "Responder",
    "download": "Descargar",
    "noPreviewAvailable": "La previsualización no está disponible",
    "userNotFound": "Usuario no encontrado",
    "userNotFoundMessage": "Usuario no encontrado",
    "thisGroupIsPrivate": "Este grupo es privado",
    "unableToPreviewPdf": "Actualmente, no se puede previsualizar el archivo PDF. Descárguelo para verlo.",
    "failedToDownloadPdf": "No se ha podido descargar el archivo PDF",
    "notifyAll": "Notificar a todos en el canal",
    "communities": "Comunidades",
    "courses": "Cursos",
    "affiliates": "Afiliados",
    "chats": "Chat",
    "switchToDarkMode": "Cambiar al modo oscuro",
    "switchToLightMode": "Cambiar al modo claro",
    "editProfile": "Editar perfil",
    "account": "Cuenta",
    "logout": "Cierre de sesión",
    "noResults": "No hay resultados",
    "confirmPayment": "Confirmar el pago",
    "done": "Hecho",
    "manage": "GESTIONAR",
    "copied": "Copiado",
    "submit": "Enviar",
    "request": "Solicitud",
    "approve": "Aprobar",
    "decline": "Rechazar",
    "comingSoon": "Próximamente",
    "detailsUpdatedSuccessfully": "Información actualizada correctamente",
    "oopsUnableToSaveDetails": "¡Vaya! No se han podido guardar los detalles.",
    "verificationFailedPleaseTryAgain": "La verificación ha fallado. Inténtelo de nuevo",
    "loading": "Cargando",
    "title": "Título",
    "addLink": "Añadir enlace",
    "writeHere": "Escribe aquí",
    "copy": "Copiar",
    "reset": "Restablecer",
    "register": "Registrarse",
    "search": "Buscar",
    "confirm": "Confirmar",
    "success": "Éxito",
    "toReview": "Para Reseña",
    "invite": "Invitar",
    "contributions": "Contribuciones",
    "communitiesSettings": "Configuración de las comunidades",
    "create": "Crear",
    "name": "Nombre",
    "linkCopied": "¡Enlace Copiado!",
    "move": "Mover",
    "irreversible": "irreversible",
    "close": "Cerrar",
    "greeting": "¡Hola, {name}!",
    "managePayments": "Gestionar los pagos",
    "manageYourAccount": "Gestionar tu Cuenta",
    "accountSettings": "Configuración de la Cuenta",
    "proceed": "Proceder",
    "uploading": "Subiendo",
    "retry": "Reintentar",
    "login": "Iniciar sesión",
    "follow": "Seguir",
    "following": "Siguiente",
    "followers": "Seguidores",
    "view": "VER",
    "selectAnOption": "Seleccionar una opción",
    "channels": "Canales",
    "somethingWentWrong": "Algo ha ido mal; inténtelo de nuevo",
    "switchToNormalMode": "Cambie al modo normal",
    "switchToReadingMode": "Cambiar al modo de lectura",
    "goToHomepage": "Ir a la página de inicio",
    "onlyGroupOwnersCanCreateCourses": "Solo los propietarios del grupo pueden crear nuevos cursos",
    "createGroup": "Crear grupo",
    "discover": "Discover",
    "continuePayment": "Continuar con el pago",
    "invalidCredentials": "Ha introducido un correo electrónico o un password no válidos. Inténtelo de nuevo.",
    "comingUpEvents": "¡Próximos eventos!",
    "integratePaymentGateway": "Integrar la pasarela de pago",
    "connectPaymentGateway": "Conecte una nueva pasarela de pago o gestione las actuales.",
    "isLive": "está en directo",
    "justNow": "Ahora mismo",
    "likes": "Me gusta",
    "accessRequired": "Acceso*",
    "zeroProgress": "0",
    "noFollowersTitle": "Parece que nadie le sigue.",
    "noFollowersSubtext": "Añadir su conexión a la lista de seguimiento",
    "noFollowingTitle": "Todavía no sigue a nadie.",
    "noFollowingSubtext": "Empiece a seguir a gente para ver sus publicaciones",
    "followBack": "Seguir también",
    "logIn": "INICIAR SESIÓN",
    "video": "Vídeo",
    "audio": "Audio",
    "newVersionAvailable": "Ya está disponible una nueva versión de la aplicación. ¡Actualice para utilizar esta función!",
    "ariaLabels": {
      "backButton": "Botón Atrás",
      "openEventLocation": "Abrir ubicación del evento",
      "editEvent": "Editar evento",
      "deleteEvent": "Eliminar evento",
      "cancelRsvp": "Cancelar confirmación de asistencia",
      "publicGroupRadio": "Botón de opción de grupo público",
      "privateGroupRadio": "Botón de opción de grupo privado",
      "accessibleFromSwitcherCheckbox": "Casilla de verificación Accesible desde el conmutador",
      "allowMembersToInviteCheckbox": "Casilla de verificación Permitir que los miembros inviten",
      "addMembers": "Añadir miembros",
      "settings": "Configuración",
      "leaveChannel": "Abandonar el canal",
      "channelSettings": "Configuración del canal",
      "selectRole": "Seleccionar rol",
      "deleteChannel": "Eliminar canal",
      "changeToPrivateChannel": "Cambiar a Canal Privado",
      "allowMembersToPosts": "Permitir que los miembros publiquen",
      "restrictMembersFromPosts": "Restringir a los miembros el envío de publicaciones",
      "close": "Cerrar",
      "open": "Abrir",
      "more": "Más",
      "upload": "Subir",
      "play": "Reproducir",
      "pause": "Pausar",
      "mute": "En silencio",
      "unmute": "Activar sonido",
      "fullscreen": "Pantalla completa",
      "exitFullscreen": "Salir de pantalla completa",
      "download": "Descargar",
      "share": "Compartir",
      "like": "Me gusta",
      "comment": "Comentario",
      "reply": "Responder",
      "pin": "Anclar",
      "unpin": "Desanclar",
      "report": "Informe",
      "copyLink": "Copiar enlace",
      "embedCode": "Incrustar código",
      "previewImage": "Previsualizar la imagen",
      "profileImage": "Imagen de perfil",
      "coverImage": "Imagen de portada",
      "thumbnail": "Miniatura",
      "attachment": "Archivo adjunto",
      "removeAttachment": "Borrar archivo adjunto",
      "uploadFile": "Subir archivo",
      "selectFile": "Seleccionar un archivo",
      "searchIcon": "Icono de búsqueda",
      "menuIcon": "Icono de menú",
      "notification": "Notificación",
      "messages": "Mensajes",
      "profile": "Perfil",
      "logout": "Cerrar sesión",
      "send": "Enviar",
      "cancel": "Cancelar",
      "submit": "Enviar",
      "next": "Siguiente",
      "previous": "Anterior",
      "refresh": "Actualizar",
      "filter": "Filtrar",
      "sort": "Ordenar",
      "view": "Visualizar",
      "expand": "Mostrar más",
      "collapse": "Contraer",
      "downloadFile": "Descargar archivo",
      "closeModal": "Cerrar el modal",
      "addMedia": "Añadir contenido multimedia",
      "lightModeRadio": "Botón de opción de modo claro",
      "darkModeRadio": "Botón de opción de modo oscuro",
      "communityThemeRadio": "Botón de opción de tema de la comunidad",
      "userProfile": "Perfil de Usuario",
      "postActions": "Acciones de publicación",
      "chatWindow": "Ventana de Chat",
      "chatActions": "Acciones de chat",
      "minimizeChat": "Minimizar chat",
      "closeChat": "Cerrar chat",
      "commentActions": "Acciones de comentario",
      "replyToComment": "Responder al comentario",
      "groupLogo": "Logotipo del grupo",
      "pinGroupIcon": "Anclar icono de comunidad",
      "appSwitcher": "Conmutador de aplicaciones",
      "communities": "Comunidades",
      "courses": "Cursos",
      "search": "Buscar",
      "giphyLogo": "Logotipo de Giphy",
      "backToConversations": "Volver a conversaciones",
      "commentAttachments": "Adjuntos de comentarios",
      "tabSwitcher": "Conmutador de pestañas",
      "eventCover": "Portada del evento",
      "eventCoverPreview": "Previsualizar la portada del evento",
      "selectPaidEvent": "Seleccionar evento de pago",
      "selectFreeEvent": "Seleccionar evento gratis",
      "selectCurrency": "Seleccionar moneda",
      "logo": "Logotipo",
      "closeReviewMembershipAnswersModal": "Cerrar modal de revisar respuestas de suscripción",
      "liveStream": "Transmisión en directo",
      "openGroupMembers": "Abrir miembros del grupo",
      "communityBanner": "Imagen principal de la comunidad",
      "home": "Inicio",
      "mentionItem": "Mencionar artículo",
      "back": "Atrás",
      "viewGroup": "Ver grupo",
      "invitationIcon": "Icono de invitación",
      "openUserProfile": "Abrir perfil de usuario",
      "closeStream": "Cerrar transmisión",
      "groupAvatar": "Avatar de comunidad",
      "bannerImage": "Imagen de banner",
      "avatarImage": "Imagen de avatar",
      "userAvatar": "Avatar de usuario",
      "eventImage": "Imagen del evento",
      "postImage": "Imagen de la publicación",
      "channelIcon": "Icono del canal",
      "groupIcon": "Icono del grupo",
      "communityIcon": "Icono de la comunidad",
      "memberAvatar": "Avatar del miembro",
      "creatorAvatar": "Avatar del creador",
      "authorAvatar": "Avatar del autor",
      "aboutFeaturedPost": "Acerca de la publicación destacada",
      "accountSettings": "Configuración de la cuenta",
      "addChannel": "Añadir canal",
      "addCourse": "Añadir curso",
      "addEmoji": "Añadir emoji",
      "affiliates": "Afiliados",
      "announceEvents": "Anunciar eventos",
      "avatar": "Avatar",
      "badge": "Insignia",
      "camera": "Cámara",
      "cardImage": "Imagen de Tarjeta",
      "categoryName": "Nombre de la categoría",
      "channelList": "Lista de Canales",
      "channelSelect": "Seleccionar Canal",
      "chatAttachment": "Archivo adjunto de chat",
      "chats": "Chats",
      "closeCourseDetails": "Cerrar detalles del curso",
      "closeLoginModal": "Cerrar el modal de iniciar sesión",
      "closeMembershipQuestionsModal": "Cerrar el modal de preguntas sobre la suscripción",
      "closePaymentModal": "Cerrar el modal de pago",
      "commentCard": "Tarjeta de comentario",
      "communityTheme": "Tema de la comunidad",
      "conversationItem": "Elemento de conversación",
      "conversationSuggestion": "Sugerencia de conversación",
      "createChannel": "Crear canal",
      "customThemeRadio": "Botón de opción de tema personalizado",
      "deleteAnswerButton": "Botón Eliminar respuesta",
      "deleteFile": "Borrar archivo",
      "editLevelName": "Editar el nombre del nivel",
      "editProfile": "Editar perfil",
      "enterEmailAddress": "Introducir dirección de correo electrónico",
      "featuredIcon": "Icono destacado",
      "giveAdministrativePrivileges": "Otorgar privilegios administrativos",
      "gokollabLogo": "Logotipo de Gokollab",
      "icon": "Icono",
      "image": "Imagen",
      "likeContent": "Dar Me gusta al contenido",
      "link": "Enlace",
      "marketplaceGroupSlug": "Slug del grupo de mercado",
      "microphone": "Micrófono",
      "nextAttachment": "Siguiente archivo adjunto",
      "noEvents": "Sin eventos",
      "noCommunitiesIllustration": "Sin ilustración de comunidades",
      "noCoursesFound": "No se han encontrado cursos",
      "noFollowers": "Sin seguidores",
      "noFollowing": "No sigue a nadie",
      "noPostsFound": "No se han encontrado publicaciones",
      "notificationItem": "Elemento de notificación",
      "notificationsList": "Lista de notificaciones",
      "openEmbeds": "Abrir inserciones",
      "openEmbedsDrawer": "Abrir el panel de inserciones",
      "openEventColor": "Abrir color de evento",
      "openEventDetails": "Abrir detalles del evento",
      "permissionNeeded": "Permiso necesario",
      "pointsAndLevels": "Puntos y niveles",
      "previousAttachment": "Anterior archivo adjunto",
      "reactedUser": "Usuario que ha reaccionado",
      "reward": "Recompensa",
      "rewards": "Recompensas",
      "selectChannel": "Seleccionar canal",
      "selectEventOption": "Seleccionar opción de evento",
      "selectIcon": "Seleccionar icono",
      "selectTimezone": "Seleccionar zona horaria",
      "showChannelIcons": "Mostrar iconos de canal",
      "sidebarActionButton": "Botón de acción de la barra lateral",
      "speaker": "Altavoz",
      "text": "Texto",
      "thisGroupIsPrivate": "Este grupo es privado",
      "toReview": "Para revisar",
      "toggleFeaturedPost": "Mostrar/Ocultar publicación destacada",
      "toggleRewardsOptions": "Activar/Desactivar opciones de recompensas",
      "viewReplies": "Ver respuestas",
      "courseThumbnail": "course-thumbnail",
      "moreManagers": "más gerentes",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Cambiar a Canal Público",
      "showMandatoryInfoModal": "Mostrar la casilla de verificación obligatoria del modal de perfil"
    },
    "placeholders": {
      "groupName": "Nombre del grupo",
      "groupSlug": "Slug del grupo",
      "url": "URL",
      "enterPrice": "Introducir precio",
      "enterName": "Introducir el nombre",
      "enterEmail": "Introducir el correo electrónico",
      "selectTimezone": "Seleccionar zona horaria",
      "selectChannel": "Seleccionar canal",
      "enterSkoolGroupUrl": "Introduzca la URL de su grupo de Skool"
    },
    "email": "Correo electrónico",
    "errorLoadingConversations": "Error al cargar conversaciones",
    "noConversations": "Sin conversaciones"
  },
  "imageUpload": {
    "cropYourAvatar": "Recorte su avatar",
    "dragToReposition": "Arrastrar para cambiar de posición",
    "ariaLabels": {
      "imageUploader": "Cargador de Imágenes",
      "avatar": "Avatar",
      "clearFile": "Borrar archivo",
      "removeAvatar": "Eliminar avatar del perfil",
      "zoomButton": "Botón de Zoom"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Subir vídeo",
    "addVideoUsingLink": "Añadir vídeo mediante un enlace",
    "uploadImage": "Subir imagen",
    "addVideo": "Añadir vídeo"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Complete su Perfil",
    "profileIntentMessage1": "Las comunidades se sienten raras sin rostros ni nombres.",
    "profileIntentMessage2": "Los perfiles fomentan la confianza y la conexión con los demás",
    "complete": "COMPLETAR",
    "recommendedAspectRatio": "Subir un {types}. Recomendado Apariencia Porcentaje 1:1",
    "addBio": "Añadir una biografía… (opcional)"
  },
  "validations": {
    "nameRequired": "¡El nombre es obligatorio!",
    "invalidDescription": "¡Descripción no válida!"
  },
  "payment": {
    "recurringWithTrial": "Se le cobrarán {price} {currencySymbol} por {interval} después del periodo de prueba con la opción de cancelar en cualquier momento.",
    "recurring": "{price} {currencySymbol} por {interval} con la opción de cancelar en cualquier momento.",
    "oneTime": "{price} {currencySymbol} {paymentText}",
    "defaultOneTimeText": "precio único de suscripción.",
    "totalAmount": "Importe total",
    "viewBreakdown": "Ver desglose",
    "hideBreakdown": "Ocultar desglose",
    "subtotal": "Total parcial",
    "salesTax": "Impuesto sobre las ventas",
    "taxesMayApply": "Es posible que se apliquen impuestos en el proceso de pago",
    "inclTax": "Incl. impuestos",
    "totalDueToday": "Total Vence hoy",
    "trialDays": "Prueba de {days} días",
    "securePayments": "Pagos 100 % seguros y protegidos",
    "allowToChargeCard": "Al facilitar los datos de su tarjeta, autoriza a {locationName} a cargar en su tarjeta los pagos futuros de acuerdo con sus condiciones.",
    "address": {
      "country": "País",
      "state": "Región/provincia/estado",
      "zipCode": "Código postal",
      "city": "Ciudad",
      "addressLine1": "Línea de dirección 1",
      "addressLine2": "Línea de dirección 2 (Opcional)",
      "streetAndNumber": "Calle y número",
      "apartmentAndUnit": "Apartamento, suite, unidad, edificio, planta, etc.",
      "selectCountry": "Seleccionar país",
      "selectState": "Seleccionar estado",
      "calculatingTaxes": "Cálculo de impuestos",
      "continueToPayment": "Continúe con el pago",
      "validationError": "Rellene todos los campos obligatorios de dirección.",
      "taxInfo": "Usamos su dirección únicamente para calcular los impuestos aplicables."
    },
    "paymentSuccessful": "¡Pago efectuado con éxito!",
    "errors": {
      "FDS_DECLINED": "Su transacción ha sido rechazada. Por favor, póngase en contacto con el propietario de la empresa."
    }
  },
  "channel": {
    "notifications": {
      "managersEdited": "Los gestores se han editado correctamente.",
      "managersAdded": "Los gestores se han agregado correctamente.",
      "managersAddedToChannel": "gestores añadidos a",
      "membersAdded": "Miembros añadidos correctamente.",
      "memberPostingEnabled": {
        "title": "Publicación de los miembros actualizado con éxito",
        "content": "Las publicaciones de los miembros han sido habilitadas"
      },
      "roleUpdated": "¡Rol actualizado correctamente!",
      "updatedRoleOf": "Rol actualizado de {name}",
      "userRemoved": "¡Usuario eliminado correctamente!",
      "removedUserFrom": "Se eliminó a {name} de {channelName}",
      "errorOccurred": "Se ha producido un error",
      "CHANNEL_MEMBER_ROLE_UPDATE_NOT_FOUND": "No se puede actualizar el rol porque no se ha podido encontrar a este miembro.",
      "CHANNEL_MEMBER_ROLE_UPDATE_OWNER_FORBIDDEN": "Esta acción no está permitida para el propietario del grupo.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_FOUND": "No se puede eliminar al usuario porque no se ha encontrado a este miembro.",
      "CHANNEL_MEMBER_REMOVE_CHANNEL_NOT_FOUND": "No se puede eliminar al usuario porque no se ha encontrado este canal.",
      "CHANNEL_MEMBER_REMOVE_OWNER_FORBIDDEN": "El propietario del grupo no puede ser eliminado del canal.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_IN_CHANNEL": "Este usuario no es parte del canal seleccionado.",
      "updated": {
        "title": "Configuración de canal actualizada",
        "contentPrivate": "El canal {channelName} ahora es privado",
        "contentPublic": "El canal {channelName} ahora es público",
        "content": ""
      },
      "deleted": {
        "title": "El canal se ha eliminado correctamente",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Miembros añadidos correctamente.",
        "content": "{count} miembros se han añadido a {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Gestores añadidos correctamente.",
        "content": "{count} gestores añadidos a {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Publicación de los miembros actualizado con éxito",
        "content": "Las publicaciones de los miembros han sido deshabilitadas"
      },
      "visibilityChangedToPublic": "El canal {channelName} ahora es público",
      "visibilityChangedToPrivate": "El canal {channelName} ahora es privado",
      "created": {
        "title": "Nuevo canal creado",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "No se ha podido crear el canal",
          "content": "Vuelva a intentarlo más tarde"
        },
        "updateFailed": {
          "title": "Error al actualizar el canal",
          "content": "Vuelva a intentarlo más tarde"
        },
        "managersEditedFailed": {
          "title": "La actualización de los gestores no ha funcionado.",
          "content": ""
        },
        "addFailed": {
          "title": "Los gestores se han añadido correctamente",
          "content": ""
        },
        "addMembersFailed": {
          "title": "No se han podido añadir los miembros.",
          "content": ""
        }
      }
    },
    "createChannel": "Crear CANAL",
    "updateChannel": "ACTUALIZAR CANAL",
    "addMembers": "Añadir miembros",
    "addManagers": "Añadir gestores",
    "typeToAddMoreMembers": "Escribir para incluir más miembros",
    "examplePlaceholder": "ej., Juan o Juana",
    "makeChannelManager": "Crear un administrador de canales",
    "removeFromChannelManager": "Eliminar del gestor de canales",
    "manager": "Gestor",
    "channelManager": "Gestor de canales",
    "noMembersFound": "No se han encontrado miembros.",
    "noManagersFound": "No se han encontrado gestores.",
    "removeChannelMember": "Eliminar miembro del canal",
    "removeConfirmationMessage": "Seguro que desea eliminar",
    "makeManagerConfirmationMessage": "¿Seguro que desea convertir a",
    "makeManagerConfirmationMessage2": "en gestor de canales en",
    "channelName": "Nombre del canal",
    "channelIcon": "Icono del canal",
    "addChannel": "Añadir canal",
    "editChannel": "Editar Canal",
    "announcementChannel": "Canal AVISO",
    "noChannelsAvailable": "No hay canales disponibles",
    "makeChannelPrivate": "Hacer que el canal sea privado",
    "makeChannelPrivateMessage": "Restrinja el acceso de los miembros a todas las conversaciones e interacciones del canal.",
    "readOnlyChannel": "Canal de solo Leer",
    "readOnlyChannelMessage": "Los miembros pueden Ver IMPORTANTE la información y las actualizaciones, pero solo los administradores/propietarios del canal pueden Compartir aquí.",
    "createPrivateChannel": "Haga este canal privado",
    "createPrivateChannelMessage": "Solo para Miembros invitados. Los no miembros no verán este espacio",
    "allowMembersToPost": "Habilitar Miembros to Compartir",
    "allowMembersToPostMessage": "Al habilitar esta opción, Habilitar miembros para crear publicaciones y comentarios/opinión",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Al habilitar la publicación de los miembros, Habilitar cada miembro para crear y compartir publicaciones dentro del canal.",
      "mainMessage2": "Asegúrate de que todos los miembros estén al tanto de los nuevos permisos de publicación.",
      "pointer1": "Esta acción puede revertirse en cualquier Fecha.",
      "pointer2": "cada publicaciones Creado por Miembros serán visibles para Todos in el canal."
    },
    "privateChannelTooltip": "No tiene acceso a este canal",
    "restrictMembersFromPosting": "Restringir los miembros de la publicación",
    "restrictMembersFromPostingMessage": "Deshabilitar esta opción evitará que los miembros de creada O editen publicaciones y comentarios/opiniones dentro del canal.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "La publicación Deshabilitar miembros restringirá cada miembro de creada y el uso compartido de publicaciones dentro del canal.",
      "mainMessage2": "Asegúrate de que todos los miembros sean conscientes de las restricciones de publicación de Nuevos.",
      "pointer1": "Esta acción puede revertirse en cualquier Fecha.",
      "pointer2": "Todas las publicaciones Creado por Miembros Antes de este Cambiar seguirán siendo visibles para Todos in el canal."
    },
    "deleteChannel": "Eliminar canal",
    "deleteChannelMessage": "Al eliminar el canal, se perderán permanentemente todos los datos asociados.",
    "deleteChannelMessageWithCourse": "Al Eliminar el canal, se perderán permanentemente los datos de cada miembro y cualquier curso vinculado a este canal se hará público, a menos que lo elimines primero.",
    "editChannelName": "Editar el nombre del canal",
    "editChannelDescription": "Editar la descripción del canal",
    "channelNamePlaceholder": "por ejemplo, los informes de marketing",
    "editManagers": "Editar los gestores",
    "channelManagers": "Gestores de canales",
    "leaveChannel": "Abandonar el canal",
    "leaveChannelConfirmation": "¿Estás seguro de que quieres Salir de este canal?",
    "changeToPrivateChannel": "Hacer que el canal sea privado",
    "changeToPrivateChannelMessage": "Hacer que el canal sea privado restringirá el uso del canal para interacciones y conversaciones únicamente a sus miembros.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Al cambiar este canal a Privado, SLOTMAX tendrá acceso únicamente a Seleccionado miembros y administradores.",
      "mainMessage2": "Recuerda incluir a todos los miembros que desees en tu canal Privado.",
      "pointer1": "Esta Acción es",
      "pointer2": "Los nuevos miembros añadidos al canal tendrán acceso a cada PASADO debates e interacciones dentro del canal."
    },
    "changeToPublicChannel": "Hacer público el canal",
    "changeToPublicChannelMessage": "Hacer público el canal permitirá a todos los miembros del grupo ver y participar en este canal.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Al hacer público este canal, todos los miembros del grupo podrán acceder a él.",
      "mainMessage2": "Todos los Miembros del Grupo podrán ver y unirse a este Canal.",
      "pointer1": "Todos los Miembros de la comunidad tendrán Iniciar sesión a este Canal automáticamente.",
      "pointer2": "El contenido anterior del canal privado será visible para todos los miembros del grupo."
    },
    "publicChannel": "Canal público",
    "peopleWhoCanManage": "Personas que pueden gestionar",
    "addChannelHelperText": "Mostrar más comunidad: Añadir canales para debates diversos, Duet y conexión.",
    "privateChannel": "Canal privado",
    "removeFromChannel": "Eliminar del canal",
    "removeConfirmationMessage2": "de este canal",
    "findChannelManagers": "Encontrar administradores de canales",
    "removeChannelManager": "Eliminar administrador de canales",
    "irreversible": "Esta acción es irreversible"
  },
  "chat": {
    "unblockUser": "Desbloquear usuario",
    "blockUser": "Bloquear usuario",
    "blockMessage1": "Ya no podrá enviar mensajes a este usuario.",
    "blockMessage2": "Esta cuenta no se bloqueará en el grupo. Es posible que aún pueda ver sus publicaciones, comentarios y reacciones.",
    "deleteChat": "Eliminar el chat",
    "deleteChatMessage": "¿Seguro que desea borrar esta conversación?",
    "block": "Bloquear",
    "conversation": "conversación",
    "youPrefix": "Usted: ",
    "messageNotSent": "Este mensaje no se ha enviado",
    "sending": "Enviando",
    "youAndUserKnowEachOther": "Usted y {name} se conocen",
    "startConversationWithHi": "Inicie una conversación enviándole un «Hola»",
    "accountSettings": "Configuración de la cuenta",
    "blockedUserMessage": "Ha bloqueado a { name }. Ahora no puede ni enviarle ni recibir mensajes. Desbloquéelo para iniciar una conversación. Para revisar su lista de usuarios bloqueados, acceda a",
    "blockRecipientMessage": "{ name } le ha bloqueado. No puede enviarle ni recibir mensajes.",
    "nothingFound": "¡No se ha encontrado nada!",
    "pleaseCheckUsername": "Verifique el nombre de usuario y vuelva a intentarlo",
    "startChatting": "Empezar a chatear",
    "noChatYet": "Parece que aún no ha chateado con nadie.",
    "noChatYetMessage": "¡Busque un contacto y dé el primer paso!",
    "noConversationsFound": "No se han encontrado conversaciones",
    "searchMembersAndStartChatting": "Busque miembros y empiece a chatear",
    "cannotMessageDeletedUser": "Tú no puedes Subir mensajes a un Eliminado Usuario",
    "message": "Mensaje",
    "media": "Contenido multimedia",
    "files": "Archivos"
  },
  "comments": {
    "reportComment": "Denunciar el comentario",
    "reportCommentMessage": "¿Seguro que desea denunciar este comentario?",
    "deleteComment": "Eliminar el comentario",
    "editComment": "Editar comentario",
    "loadMoreReplies": "Cargar más respuestas",
    "deleteCommentMessage": "¿Seguro que desea eliminar este comentario?",
    "writeComment": "Escribir un comentario",
    "comment": "COMENTARIO",
    "cancel": "CANCELAR",
    "save": "GUARDAR",
    "replyingTo": "Respondiendo a",
    "newComment": "Nuevo comentario",
    "latest": "Más reciente",
    "onlyAdminsCanComment": "Solo los administradores de la comunidad pueden comentar in este canal.",
    "isCommentDisabledForPost": "Los comentarios están deshabilitados para este Compartir.",
    "isCommentDisabledErrorContent": "Los comentario en este Compartir han sido Deshabilitado por el Editor O el Administrador del Grupo.",
    "isCommentDisabledErrorTitle": "Comentarios Deshabilitados",
    "notifications": {
      "saveComment": "Error al guardar el comentario",
      "error": "Algo ha ido mal. Inténtelo de nuevo más tarde.",
      "COMMENT_CONTENT_SIZE_EXCEEDED": "El contenido del comentario es demasiado extenso. Reduzca el tamaño e inténtelo de nuevo.",
      "COMMENTS_DISABLED": "El autor o el administrador del grupo han desactivado los comentarios en esta publicación."
    }
  },
  "embeds": {
    "uploadImage": "Subir una imagen",
    "addYoutubeVimeoLoomLink": "Añadir un enlace de Youtube, Vimeo o Loom",
    "uploadAttachment": "Subir archivos PDF, CSV o XLSX",
    "addAttachment": "Añadir archivo adjunto",
    "allowedTypes": "SVG, PNG, JPG o GIF (máx. 800 x 400 px)",
    "placeholder": "Añadir un enlace de Youtube, Vimeo o Loom",
    "uploadVideo": "Subir o enlazar un vídeo",
    "uploadVideoPlaceholder": "Añadir un enlace de Youtube, Vimeo o Loom",
    "uploadVideoAllowedTypes": "Subir un archivo de vídeo MP4",
    "addEmoji": "Añadir emoji",
    "emojiSuggestion": "Abre el selector de emojis",
    "addGif": "Añadir GIF",
    "gifSuggestion": "Abre el selector de GIF",
    "addImage": "Añadir una imagen",
    "imageSuggestion": "Abre su galería",
    "addVideo": "Añadir vídeo",
    "videoSuggestion": "Abre su galería",
    "selectFile": "Seleccionar un archivo",
    "attachmentSuggestion": "Abre el administrador de archivos",
    "takePhoto": "Tomar una foto",
    "uploadPhotoVideo": "Subir foto/vídeo",
    "limitExceeded": "Límite excedido",
    "limitExceededMessage": "No puede adjuntar más de cuatro archivos",
    "errorWhileUploadingFile": "Error al subir el archivo. Inténtelo de nuevo",
    "notifications": {
      "uploadError": "Error al cargar el archivo",
      "FILE_SIZE_EXCEEDED": "El tamaño del archivo supera el límite máximo de 50 MB.",
      "VIDEO_SIZE_EXCEEDED": "El tamaño del vídeo supera el límite máximo de subida de 1 GB."
    },
    "clickToUpload": "Haga clic para cargar",
    "orDragAndDrop": "o arrastre y suelte",
    "validUrl": "Se necesita una URL válida",
    "enterSomeText": "Introduzca algo de texto",
    "addLink": "Añadir enlace",
    "text": "Enviar mensaje de texto",
    "addVideoLink": "O, Incluir a YouTube, Vimeo, Loom, O Wistia Vídeo Enlace.",
    "uploadVideoAndImages": "Subir vídeos e imágenes",
    "recommendedAspectRatio": "Recomendado Apariencia Porcentaje {ratio}",
    "addHashtag": "Etiquetar canales, sucesos/incidentes/repeticiones y cursos",
    "hashtagSuggestion": "Sugerencia de Hashtag"
  },
  "tabSwitcher": {
    "discussion": "Conversación",
    "learning": "Aprendizaje",
    "members": "Miembros",
    "people": "Personas",
    "leaderboard": "Tabla de clasificación",
    "channels": "Canales",
    "groups": "Grupos",
    "more": "Más",
    "home": "Inicio",
    "discover": "Descubrir",
    "courses": "Cursos",
    "communities": "Comunidades"
  },
  "groupInfo": {
    "pinGroup": "Grupo de pines",
    "unpinGroup": "Desanclar el Grupo",
    "maxPinnedGroupsLimit": "Solo se pueden fijar hasta 4 grupos",
    "publicGroup": "Grupo público",
    "privateGroup": "Grupo Privado",
    "coverImage": "Portada de grupo",
    "members": "Miembros",
    "posts": "Publicaciones",
    "admin": "Administrador",
    "settings": "CONFIGURACIÓN",
    "inviteMembers": "INVITAR MIEMBROS",
    "answerQuestions": "Responder preguntas",
    "toJoin": "para unirse a {name}",
    "leaveGroup": "Abandonar grupo",
    "leaveGroupConfirmMessage": "¿Está seguro de que desea abandonar este grupo? Perderá el acceso a todos los cursos de pago, eventos de pago y su membresía de grupo.",
    "leaveGroupSuccessTitle": "Usted ha dejado el grupo",
    "leaveGroupSuccessMessage": "Ha abandonado el grupo con éxito.",
    "leaveGroupErrorTitle": "No puede abandonar el grupo",
    "leaveGroupErrorMessage": "Algo ha ido mal al salir del grupo. Inténtelo de nuevo.",
    "groupActions": "Acciones de grupo",
    "changeRole": "Cambiar rol",
    "removeFromGroup": "Eliminar del grupo",
    "contributor": "Colaborador",
    "membershipAnswers": "Respuestas de suscripción",
    "unbanMember": "Miembro de Unban",
    "banFromGroup": "Vetar del grupo",
    "requestedOn": "Solicitado el",
    "invitedOn": "Invitado el",
    "joinedOn": "Unido",
    "noMembersFound": "No se han encontrado miembros.",
    "youAreAllCaughtUp": "Tú're cada catch up—no Miembros aquí Derecha ahora!",
    "banUserConfirmation": "¿Seguro que desea expulsar a este usuario del grupo?",
    "deleteContentCheckbox": "Borrar cada Contenido Creado por este Usuario",
    "active": "Activo",
    "admins": "Administradores",
    "contributors": "Colaboradores",
    "requested": "Solicitado",
    "banned": "Vetado",
    "invited": "Invitado",
    "paymentReceived": "Pago recibido",
    "paymentInitiated": "Pago iniciado",
    "answeredQuestions": "Preguntas respondidas",
    "answeredQuestionsMessage": "ha respondido a la siguiente pregunta para unirse",
    "darkMode": "Modo oscuro",
    "darkModeMessage": "Modificar la apariencia de la Comunidad para reducir el deslumbramiento y dar un descanso a sus ojos.",
    "accessGranted": "Acceso concedido: empiece su aventura de aprendizaje.",
    "stepIntoAction": "¡Pase a la acción! Colaboremos y divirtámonos.",
    "viewMembersAndMemberDetails": "Vea los miembros y sus detalles",
    "reviewContentReportsAndMore": "Revise informes de contenidos multimedia y mucho más",
    "toReview": "Para revisar",
    "switchToOtherGroups": "Cambiar a Otro Grupo",
    "placeholders": {
      "yourAnswer": "Su respuesta"
    },
    "notifications": {
      "userBanned": "Usuario vetado correctamente del grupo",
      "somethingWentWrong": "Algo ha ido mal. Inténtelo de nuevo más tarde."
    },
    "membershipSettings": "Configuración de afiliación",
    "paymentFailed": "El pago ha fallado.",
    "paymentFailedMessage": "Error en el pago. Su solicitud para unirse al grupo ha sido rechazada.",
    "gamification": {
      "addRewards": "Añadir recompensas",
      "title": "Título",
      "description": "Añadir descripción",
      "textbox": "Cuadro de texto",
      "singleSelect": "Selección única",
      "multipleSelect": "Selección múltiple",
      "question": "Pregunta",
      "validations": {
        "titleRequired": "Indique un título",
        "descriptionRequired": "Proporcione una descripción",
        "somethingWentWrong": "Algo ha ido mal. Inténtelo de nuevo más tarde.",
        "updatedRewards": "Recompensas actualizadas"
      },
      "settings": {
        "updatedRewards": "Recompensas actualizadas"
      }
    },
    "customCode": {
      "advanced": "Avanzado",
      "testPreview": "Previsualizar la prueba",
      "enableConfirmationMessage": "Habilítelo únicamente una vez que haya verificado la vista previa de la prueba",
      "testPreviewMessage": "Esto abrirá una nueva pestaña con la vista previa de la prueba de su comunidad. Puede usar esto para comprobar si su código personalizado funciona como se esperaba.",
      "liveMode": "Modo en tiempo En tiempo real",
      "customJS": "JS Personalizado",
      "customCSS": "CSS Personalizado",
      "trackingCode": "Código de seguimiento",
      "headerCode": "Código del Encabezado",
      "footerCode": "Código de Pie de página"
    },
    "branding": {
      "brandYourGroup": "Puede marcar su grupo como lo prefiera aquí",
      "updateBranding": "Actualizar la creación de la marca",
      "clickToUploadFavicon": "Haga clic para subir el favicón",
      "dragAndDropFavicon": "Arrastrar y soltar un {types} (relación de aspecto 1:1)",
      "clickToUploadCover": "Haga clic para subir la portada",
      "dragAndDropCover": "Arrastrar y soltar un {types} (relación de aspecto 16:9)",
      "clickToUploadLogo": "Haga clic para subir el logotipo del grupo",
      "dragAndDropLogo": "Arrastrar y soltar un {types} (relación de aspecto 1:1)",
      "aspectRatioMustBe1To1": "La relación de aspecto de la imagen debe ser 1:1",
      "aspectRatioMustBe16To9": "La relación de aspecto de la imagen debe ser de 16:9",
      "favicon": "Favicón",
      "coverImage": "Imagen de portada",
      "logo": "Logotipo",
      "invalidFileFormat": "¡Vaya! Formato o tipo de archivo no válido.",
      "pleaseUploadImageType": "Tipos de archivo admitidos: {types}"
    },
    "groupAppearance": {
      "description": "Puedes configurar tu Grupo Apariencia según tu elección aquí",
      "slug": "Actualizar tu Grupo Apariencia aquí",
      "colorMode": "Modo de Color",
      "previewTheLook": "Previsualizar cómo será la apariencia de tu grupo in modo claro/ligero y oscuro",
      "light": "Claro/ligero",
      "dark": "Oscuro",
      "communityTheme": "Tema de la comunidad",
      "customTheme": "Tema Personalizado",
      "windowGradient": "Gradiente de la Ventana",
      "applyGradientColorsToYourSidebarAndTopbar": "Aplica colores degradados a tu barra lateral y barra superior",
      "labels": {
        "sidebarBackground": "Fondo de la barra lateral",
        "primary": "DIRECTOR",
        "secondary": "Secundario",
        "tertiary": "Terciario",
        "surface": "Superficie",
        "fontPrimary": "PRINCIPAL Fuente",
        "fontSecondary": "Fuente secundaria",
        "fill": "Color de Rellenar",
        "border": "Borde",
        "error": "Error",
        "background": "Fondo",
        "option": "Opción"
      },
      "customThemes": {
        "default": "Por defecto",
        "zestyCitrus": "Cítricos picantes",
        "royalVelvet": "Terciopelo real",
        "sunnyDelight": "Delicia soleada",
        "lushMeadow": "Prado frondoso",
        "azureDreams": "Sueños azures",
        "bubblegumBliss": "Felicidad de la goma de mascar",
        "ivoryWhisper": "Susurro de marfil",
        "midnightDeep": "Medianoche profunda"
      },
      "unsavedChanges": "No guardado",
      "unsavedChangesMessage": "Tú no has guardado el Tema Dinámico. ¿Estás seguro de que quieres Deshacer el Dinámico?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Enlaces promocionales",
      "createPromotionalLinkDescription": "Cree enlaces promocionales para su grupo",
      "addPromotionalLink": "Añadir enlace",
      "deleteLink": "Eliminar enlace",
      "deleteLinkConfirmation": "¿Seguro que desea eliminar este enlace?",
      "labels": {
        "description": "Descripción",
        "url": "URL",
        "private": "Privado",
        "privateLinksDescription": "Los enlaces privados solo son visibles para los miembros del grupo"
      },
      "placeholders": {
        "enterLinkDescription": "Introducir la descripción del enlace",
        "enterLinkURL": "Introduzca la URL del enlace"
      },
      "addPromotionalLinkDescription": "Crear Enlaces promocionales para tu Grupo",
      "ariaLabels": {
        "editLink": "Editar enlace",
        "deleteLink": "Eliminar enlace"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Añadir pregunta",
      "editQuestion": "Editar pregunta",
      "editLevelName": "Editar el nombre del nivel",
      "addOption": "Añadir opción",
      "level": "Nivel",
      "name": "Nombre",
      "addMembersQuestionsDescription": "Añada preguntas para formular a los miembros cuando soliciten acceso a su grupo",
      "enableMembershipQuestions": "Habilitar preguntas de suscripción",
      "membershipQuestions": "Preguntas de suscripción",
      "deleteQuestion": "Eliminar pregunta",
      "deleteQuestionConfirmation": "¿Seguro que desea eliminar esta pregunta?",
      "labels": {
        "textBox": "Cuadro de texto",
        "singleSelect": "Selección única",
        "multipleSelect": "Selección múltiple",
        "enableMembershipQuestions": "Añadir al menos una Pregunta a Habilitar membresía preguntas"
      },
      "validations": {
        "questionRequired": "Introduzca una pregunta",
        "answerOptionsRequired": "Se requiere un mínimo de dos opciones y deben ser únicas",
        "somethingWentWrong": "Algo ha ido mal. Inténtelo de nuevo más tarde.",
        "updatedQuestions": "Preguntas de suscripción al grupo actualizadas",
        "levelNameRequired": "Introduzca el nombre del nivel",
        "updatedLevelName": "Nombre del nivel actualizado"
      },
      "placeholders": {
        "enterLevelName": "Nombre del nivel",
        "selectOne": "Seleccionar uno",
        "keepItShort": "sea breve...",
        "exampleOffer": "P. ej. 10% Deshabilitado Activado primera compra"
      },
      "privacyNotice": "Entiendo que mis respuestas estarán Archivando y visibles para los administradores del Grupo.",
      "ariaLabels": {
        "editQuestion": "Editar pregunta",
        "deleteQuestion": "Eliminar pregunta"
      }
    },
    "gamificationAndRewards": {
      "title": "Personalizar niveles y recompensas",
      "description": "Personalice los nombres de los niveles e incluya recompensas para fomentar la participación de los miembros",
      "gamification": "Ludificación",
      "rewards": "Recompensas",
      "addRewards": "Añadir recompensa",
      "ariaLabels": {
        "toggleGamification": "Activar/Desactivar opciones de ludificación"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Invitación enviada con éxito",
      "invitationSentSuccessfullyDescription": "Invitación enviada a {email}",
      "shareGroupLink": "Comparta el enlace de su grupo",
      "inviteMember": "Invitar a un miembro",
      "inviteMemberDescription": "Construya su comunidad invitando a un nuevo miembro",
      "inviteViaEmail": "Invitar por correo electrónico",
      "invitedMembersWillBeAutoApproved": "Los miembros invitados recibirán la aprobación automática para unirse al grupo",
      "sendInvite": "ENVIAR INVITACIÓN",
      "permissionDenied": "Tú no tienes Autorización para invitar a Miembros. Ponte en contacto con el administrador.",
      "notifications": {
        "INVITATION_CREATE_UNAUTHORIZED": "No tiene permiso para enviar invitaciones.",
        "INVITATION_CREATE_GROUP_DISALLOWS_INVITE": "Este grupo no permite que los miembros inviten a otras personas.",
        "INVITATION_CREATE_ALREADY_INVITED": "Este usuario ya ha recibido una invitación.",
        "INVITATION_CREATE_ALREADY_MEMBER": "Este usuario ya pertenece al grupo."
      },
      "labels": {
        "giveAdministrativePrivileges": "Otorgue privilegios administrativos",
        "giveAdministrativePrivilegesDescription": "Permita a este miembro llevar a cabo todas las acciones administrativas",
        "name": "Nombre",
        "email": "Correo electrónico",
        "nameLabel": "Nombre",
        "emailLabel": "Correo electrónico"
      },
      "placeholders": {
        "enterName": "Introducir el nombre",
        "enterEmail": "Introducir el correo electrónico"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Actualizar la información del grupo",
      "updateGroupDetailsDescription": "Actualizar los detalles de su grupo aquí",
      "slugNotAvailable": "Slug del grupo no disponible",
      "description": "Detalle la naturaleza de los debates que tendrán lugar en el grupo",
      "publicDescription": "Cualquiera puede ver las publicaciones del grupo y a los otros miembros del grupo",
      "privateDescription": "Solo los miembros pueden ver las publicaciones de la colección y a otros miembros de la colección.",
      "accessibleFromSwitcher": "Accesible desde el conmutador",
      "accessibleFromSwitcherDescription": "Su grupo será visible en el conmutador para los no miembros del grupo.",
      "allowMembersToInvite": "Habilitar a los miembros para invitar a Nuevos Miembros",
      "allowMembersToInviteDescription": "Ocultar el Botón de invitación para los miembros Cuando esté deshabilitado. Los miembros solo pueden invitar a Otro Si esto es Habilitado.",
      "showMandatoryInfoModal": "Mostrar modal de perfil obligatorio",
      "showMandatoryInfoModalDescription": "Cuando esté habilitado, se solicitará a los miembros que completen la información de su perfil cuando se unan al grupo.",
      "slug": "Slug del grupo",
      "discovery": {
        "title": "Descubrimiento",
        "description": "Permita que millones de usuarios activos le descubran. El grupo será visible en la página de descubrir una vez que tenga más de 10 miembros.",
        "discoverChannels": "Descubrir canales",
        "joinGroupToExploreAllChannels": "unirse al grupo para explorar cada uno de los canales",
        "categoryIsUsedOnlyOnGokollab": "La categoría se usa solo en Gokollab",
        "categoryAutomaticallySuggested": "La categoría se sugiere automáticamente mediante AI en función del título y la descripción de su grupo. Para obtener una sugerencia más precisa, asegúrese de que los detalles de su grupo reflejen claramente su objetivo y sus temas.",
        "categoryRefreshLimited": "La actualización de categoría está limitada a una vez cada 24 horas"
      },
      "placeholders": {
        "description": "Introducir una breve descripción"
      },
      "validations": {
        "nameRequired": "Introduzca un nombre de grupo válido.",
        "slugRequired": "Introduzca un slug de grupo válido.",
        "specialCharacterNotSupported": "Carácter especial no admitido",
        "descriptionRequired": "La descripción del grupo es obligatoria.",
        "emailRequired": "Introduzca un correo electrónico válido.",
        "fullNameRequired": "Introduce un nombre válido."
      },
      "labels": {
        "groupName": "Nombre del Grupo"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Gestionar tu Suscripción",
      "viewAndManageGroupSubscriptions": "Ver y Gestionar Grupo Suscripción",
      "paymentIntegrationMissingMessage": "Por favor, integra los pagos in la Ubicación para Habilitar Pagado Grupo",
      "price": "Precio",
      "currency": "Moneda",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Una fecha",
      "priceDeletedAlert": "El producto de Pago es de sincronización, haz clic aquí para resincronizar",
      "intervals": {
        "month": "Mes",
        "year": "Año",
        "week": "Semana",
        "day": "Día"
      },
      "addNewPrice": "Añadir Nuevo Precio",
      "editPrice": "Editar el Precio",
      "addPrice": "Añadir Precio",
      "subscriptionType": {
        "recurring": "Recurrente",
        "oneTime": "Una fecha"
      },
      "billingPeriod": {
        "monthly": "Mensual",
        "annually": "Anualmente",
        "weekly": "Semanal",
        "daily": "Diario"
      },
      "ariaLabels": {
        "freeMembership": "Botón de opción de suscripción gratis",
        "paidMembership": "Botón de opción de suscripción de pago"
      }
    },
    "menuOptions": {
      "details": "Detalles",
      "subscriptions": "Suscripción",
      "branding": "Creación de marca",
      "themes": "Tema",
      "tabsConfiguration": "Mostrar / Ocultar Pestañas",
      "membershipQuestions": "Preguntas Membresía",
      "gamificationAndRewards": "Ludificación y recompensas",
      "links": "Enlaces",
      "newsletter": "Boletín",
      "reportedContent": "Contenido denunciado",
      "discovery": "Descubrimiento",
      "import": "Importar"
    },
    "newsletter": {
      "title": "Boletín",
      "subheading": "El Resumen de Su Comunidad",
      "frequency": "Frecuencia del Boletín",
      "description": "Un Resumen de las publicaciones populares, la Actividad de los Miembros y los eventos de este grupo",
      "time": "Horario",
      "weekday": "Día laborable",
      "monthDay": "Día del mes",
      "lastDay": "Último día",
      "selectFrequency": "Seleccione la frecuencia",
      "frequencies": {
        "off": "Apagado",
        "daily": "Diario",
        "weekly": "Semanal",
        "biweekly": "Quincenal",
        "monthly": "Mensual"
      }
    },
    "tabConfiguration": {
      "title": "Mostrar / Ocultar Pestañas",
      "description": "Controle qué pestañas aparecen en su comunidad. Active o desactive cada pestaña para crear una experiencia focalizada y optimizada para sus miembros.",
      "discussionDescription": "Inicie o únase a conversaciones para compartir actualizaciones, ideas e información importante con su comunidad.",
      "learningDescription": "Cree y gestione cursos que ayuden a los miembros a adquirir nuevas habilidades y conocimientos.",
      "eventsDescription": "Planifique, organice y consulte las próximas sesiones, talleres o eventos comunitarios.",
      "leaderboardDescription": "Reconozca a los miembros de mejor rendimiento y fomente una participación saludable a través de las clasificaciones.",
      "membersDescription": "Gestione a todos los miembros y roles. Esta pestaña seguirá siendo visible para los administradores incluso cuando esté desactivada, de modo que la gestión de miembros siempre sea accesible.",
      "aboutDescription": "Introduzca el propósito, los valores y los orígenes de su comunidad para ayudar a los miembros a crear conexiones.",
      "discussionTooltip": "La pestaña de discusión es fundamental en la comunidad y no se puede desactivar",
      "aboutTooltip": "La pestaña «Acerca de» es necesaria para proporcionar información esencial de la comunidad y no se puede desactivar."
    },
    "groupSettings": {
      "groupSettings": "Configuración del Grupo",
      "changeGroupType": "Cambiar el Tipo de Grupo",
      "changeGroupTypeDescriptionPrivateToPublic": "Dinámico to a Público Grupo significa que cada Solicitud pendiente será Aceptado automáticamente y el Contenido se hará visible públicamente. ¿ Proceder?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dinámico a un Grupo Privado significa que los Nuevos Miembros necesitan Aprobación y el Contenido permanece Oculto hasta que se Aceptado. ¿ Proceder?",
      "changeGroupTypeConfirmation": "¿Estás seguro de que quieres Cambiar el Grupo Tipo?",
      "changeGroupTheme": "Cambiar el Tema del Grupo",
      "changeGroupThemeDescription": "Esto cambiará el Tema para cada Grupo de Miembros. ¿Estás seguro de que quieres Cambiar el Grupo Tema?",
      "updatedGroupDetails": "Detalles Actualizado del Grupo",
      "unableToSaveDetails": "¡Vaya!! No se ha podido archivar los detalles.",
      "groupNameIsRequired": "El Nombre del grupo es obligatorio",
      "groupDescriptionIsRequired": "El Grupo Descripción es Obligatorio",
      "groupSlugIsRequired": "El Grupo Slug es Obligatorio",
      "groupSlugMustContainOnly": "El Grupo Slug debe contener solo las letras Minúscula, Cantidad y guiones",
      "groupSlugAlreadyExists": "El Slug del Grupo ya existe. Utiliza un Slug diferente, ya que este ya está tomado",
      "groupSlugRestricted": "Este Slug coincide con una de nuestras palabras clave restringidas para enlaces de la comunidad. Use un Slug diferente",
      "pleaseTryAgainLater": "Por favor, Vuelve a intentarlo más tarde",
      "unsavedChangesMessage": "Tú no has guardado al Grupo Slug Dinámico. ¿Estás seguro de que quieres deshacerlo?"
    },
    "import": {
      "header": "Importar Miembros de Skool Grupo y su Contenido",
      "credentialDescription": "Introduce tu Certificado de Skool para importar tu Grupo de miembros y su Contenido",
      "csvUploadDescription": "Seleccionar .csv Archivo para Importar contactos De Skool",
      "loginFailed": "No has introducido un correo electrónico válido O password. Por favor, Vuelve a intentarlo.",
      "proceedWithImport": "¿Proceder con la Importar?",
      "iAgree": "Estoy de acuerdo",
      "importTerms": "Al hacer clic en «Acepto», confirmas y reconoces que nos has contratado como Trato independiente para que prestemos los Servicios Activado en tu nombre («Servicios»). Los servicios incluyen la transferencia de ciertos datos, detalles, contenido, propiedades intelectuales o cualquier otro contenido (\"Información\") de un Emitido Platform Cuenta a un Recibido Platform Cuenta. Tú declaras y garantizas que (i) tú es el propietario legítimo de la información in la cuenta de la plataforma Emitido, (ii) tienes los permisos para concedernos el acceso a la cuenta de la plataforma Emitido con el intento de prestar los servicios, y (iii) la Transferir de la Información no infringirá las propiedades intelectuales permitidas de terceros ni violará ningún contrato de terceros. Aceptas indemnizar, defender y En espera nos indemne por cualquier reclamación de terceros que surja como Resultado de tu incumplimiento de las declaraciones y garantías anteriores.",
      "pleaseDownloadCSV": "Descarga el archivo .CSV",
      "step01": "Paso 01-",
      "step02": "Paso 02-",
      "uploadCSV": "Subir tu .CSV",
      "step01Description": "Rellenar in O actualiza los Detalles que faltan para el Grupo Miembros, como Gmail, el nombre de pila, etc. Asegúrate de que el CSV se suba in",
      "thisTemplate": "esta Plantilla",
      "importCSV": "Importar .CSV",
      "reSyncData": "Re-Sincronización de tus datos Antes de descargar.",
      "refreshUserList": "Actualizar Usuario Lista",
      "reSyncDataDescription": "Si, in tanto, se añaden Nuevos Usuarios, te sugerimos que actualices tu Lista y descargues el CSV.",
      "pleaseDontChangeProfileSlug": "Por favor, no cambies el perfil de Slug.",
      "selectFile": "Seleccionar Archivo",
      "changeFile": "Cambiar Archivo",
      "importMembersFailedText": "Esto puede deberse a que falta el Correo electrónico Dirección. Por favor, Marca de verificación tu Importar Archivo y Vuelve a intentarlo con una dirección de correo electrónico válida para estos miembros.",
      "upload": "Subir",
      "tryAgain": "Vuelve a intentarlo",
      "importerAnotherGroup": "Start New Import",
      "syncAllPosts": "Sincronización cada tu Compartir y Comentario",
      "membersCouldNotBeAdded": "No se han podido añadir los miembros al grupo.",
      "importMembersSuccess": "Hemos enviado un Correo electrónico a cada miembro Individual del Grupo, confirmando su Membresía in el Grupo y proporcionándoles el Acceso Detalles. Esto ayuda a garantizar que todos los miembros estén informados y puedan acceder al grupo de forma eficaz.",
      "importMembersAdded": "Los miembros han sido añadidos correctamente al Grupo",
      "postsNotSynced": "Las publicaciones restantes no han podido ser sincronizadas con el grupo. Esto puede deberse a que los Autores Compartir no se han importado correctamente.",
      "migrationFailed": "La migración ha fallado. Por favor, Vuelve a intentarlo.",
      "migrationCompleted": "Migración ¡Hecho!",
      "migrationInProgress": "Migración en curso",
      "createProfile": "Crear perfil",
      "enterCredentials": "Introducir credenciales",
      "uploadingInProgress": "¡Subir in progreso!",
      "listMembers": "La Lista de Miembros está siendo",
      "downloaded": "Descargar",
      "uploaded": "subido",
      "listPostsDownloaded": "La lista de publicaciones es Descargar.",
      "listPostsDownloading": "La lista de publicaciones está siendo descargada.",
      "posts": "publicaciones",
      "members": "Miembros",
      "imported": "importado",
      "step1": "Paso 1",
      "step2": "Paso 2",
      "step1Description": "Crear a Miembros Perfil in Skool Grupo.",
      "step1Description2": "(incluidos el Nombre, el correo electrónico Id y la contraseña)",
      "step2Description": "Introducir Skool Miembros Certificado",
      "skoolUrlPlaceholder": "Introduzca la URL de su grupo de Skool",
      "emailPlaceholder": "Introduce tu Idde correo electrónico de Skool",
      "emailTooltip": "Introduce al Correo electrónico miembros con tu Cuenta Skool",
      "passwordPlaceholder": "Introduce tu contraseña de Skool",
      "confirm": "Confirmar",
      "validation": {
        "skoolUrl": "Introduce una URL de Skool válida",
        "email": "El correo electrónico es obligatorio",
        "password": "La contraseña es obligatoria"
      }
    },
    "approved": "Aprobado",
    "pending": "Pendiente",
    "rejected": "Rechazado"
  },
  "invitations": {
    "intent": "¡Ayude a crecer a esta comunidad!",
    "cancelInvitation": "Cancelar la invitación",
    "inviteMembers": "Invite a los miembros a colaborar en esta comunidad.",
    "inviteLink": "Enlace de invitación",
    "invitationLink": "enlace de invitación",
    "buildYourCommunity": "¡Construya su comunidad!",
    "inviteMembersToCollaborate": "¡Ha creado una nueva comunidad! Invite a los miembros a colaborar en esta comunidad.",
    "invite": "Invitar",
    "basicInformation": "Información básica",
    "permissions": "Permisos"
  },
  "createPost": {
    "title": "Crear una nueva publicación del blog",
    "placeholder": "¿En qué está pensando?",
    "liveStream": "Transmisión en directo",
    "slug": "URL de la publicación del blog",
    "titleHelp": "El título, la descripción y la imagen se utilizarán para la metaetiqueta SEO",
    "nameLabel": "Título de la publicación de blog",
    "nameValidation": "El título es obligatorio",
    "descriptionLabel": "Descripción de la publicación",
    "descriptionHelp": "Proporcione una breve descripción para que los espectadores puedan hacerse una idea de la publicación. Lo mejor es entre 100 y 250 caracteres",
    "descriptionValidation": "La descripción es obligatoria",
    "createLabel": "Crear publicación",
    "image": "Imagen de la publicación del blog",
    "imageDescription": "El tamaño recomendado es 600px * 400px",
    "notificationTitle": "Publicación de blog creada",
    "notificationErrorTitle": "Error al crear la publicación del blog",
    "postingIn": "Publicar in",
    "editingIn": "Editando in"
  },
  "post": {
    "downloadRecording": "Descargar la grabación",
    "deletePost": "Eliminar la publicación",
    "reportPost": "Denunciar la publicación",
    "editPost": "Editar publicación",
    "createPost": "Crear publicación",
    "publish": "Publicación",
    "publishPost": "Publicar la publicación",
    "addChannel": "Añadir canal",
    "selectChannel": "Seleccione el canal",
    "addLink": "Añadir enlace",
    "removeLink": "Eliminar el enlace",
    "update": "Actualizar",
    "unsavedChanges": "Tiene cambios sin guardar",
    "unsavedChangesMessage": "Los cambios no guardados se perderán. ¿Aún desea continuar?",
    "unpinFromChannel": "Desanclar",
    "unpinFromHome": "Desanclar",
    "deletePostConfirmation": "¿Seguro que desea eliminar esta publicación?",
    "reportPostConfirmation": "¿Seguro que desea denunciar esta publicación?",
    "postNotFound": "No se ha encontrado la publicación",
    "postNotFoundMessage": "La publicación que intenta ver ha sido eliminada o no existe.",
    "loadMoreComments": "Cargar más comentarios",
    "channelNotFound": "Canal no encontrado",
    "isCurrentlyLive": "está en directo ahora",
    "isStartingNow": "está empezando ahora",
    "isHappeningInMinutes": "tendrá lugar en {minutes} minutos",
    "isHappeningInHours": "está ocurriendo in {hours} hora | está ocurriendo in {hours} hora",
    "publicChannel": "Canal público",
    "privateChannel": "Canal privado",
    "featured": "Destacado",
    "featuredAbout": "Acerca de los destacados",
    "noPostsFound": "No se han encontrado publicaciones",
    "pinInfo": "Puede anclar elementos para que aparezcan en la parte superior del grupo, incluidas publicaciones, reglas y hashtags.",
    "pinInfoEveryone": "Todos los miembros del grupo verán estos elementos.",
    "pinInfoRemainVisible": "Los objetos anclados permanecen visibles hasta que los desbloquee.",
    "pinInfoNewestItem": "A medida que ancla elementos, el más reciente aparece al principio de la lista.",
    "onlyVisibleToAdmins": "Solo visible para los administradores",
    "featuredAboutDescription": "Los administradores han anclado estos elementos para que el grupo los vea.",
    "channelNotFoundMessage": "Usted ya no es miembro del canal al que intenta acceder o el canal ha sido eliminado.",
    "notifications": {
      "unpinned": "¡Desanclado!",
      "pinned": "¡Fijado!",
      "reported": "¡La publicación ha sido reportada!",
      "error": "¡Algo ha ido mal!",
      "isCommentDisabled": "¡Comentarios Deshabilitados!",
      "isCommentEnabled": "¡Comentarios habilitados!",
      "createPost": "Error al crear la entrada",
      "editPost": "Error al editar la publicación",
      "POST_CONTENT_SIZE_EXCEEDED": "El contenido de la publicación es demasiado grande. Reduzca el tamaño e inténtelo de nuevo."
    },
    "movePostToChannel": "Mover al Canal",
    "pin": "Fijar",
    "pinToHome": "Anclar a Inicio",
    "pinToChannel": "Anclar al Canal",
    "whatIsYourTitle": "¿Cuál es tu Título?",
    "postMovedToChannel": "Compartir movido al canal {channelName}",
    "upcomingEvent": "Próximo evento",
    "turnOffCommenting": "Deshabilitar los comentarios",
    "enableComments": "Guardar comentario",
    "disableComments": "Deshabilitar comentario",
    "moveToPrivateChannelConfirmation": {
      "title": "Trasladar al canal privado",
      "message": "Está a punto de trasladar esta publicación a un canal privado. Solo los miembros de ese canal privado podrán verla. ¿Quiere continuar?"
    },
    "onlyAdminsCanPost": "Solo los administradores de la comunidad pueden compartir en este Canal."
  },
  "reaction": {
    "noLikes": "No hay ningún «Me gusta»",
    "andOthers": "y {count} otros"
  },
  "UIConfirmation": {
    "privateGroup": "Este grupo es privado",
    "privateGroupMessage": "Debe ser miembro de este grupo para acceder a su información específica. Solicite el acceso haciendo clic en el botón «Unirse al grupo»."
  },
  "notifications": {
    "noNotificationsYet": "Aún no hay notificaciones",
    "whenYouGetNotifications": "Cuando reciba notificaciones, se mostrarán aquí",
    "markAllAsRead": "Marcar todo como leído",
    "notifications": "Notificaciones",
    "all": "Todos",
    "unread": "No leído",
    "checkNotifications": "Iniciar sesión para comprobar las notificaciones",
    "noNotifications": "No hay notificaciones",
    "redirectedFromOldSlug": {
      "title": "Te has redirigido al Enlace Actualizado de la comunidad",
      "content": "Esto se ha hecho para mejorar el rendimiento del SEO de esta comunidad. Por favor, Actualice sus marcadores con esta nueva URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "¡Bravo! 🎉 Solicitud enviada correctamente",
    "reviewRequestSoon": "Los administradores del grupo revisarán su solicitud en breve. Le rogamos sea paciente. Le avisaremos en cuanto se apruebe su suscripción.",
    "nonMemberMessage": "Necesita formar parte de este grupo para dar «me gusta» y comentar las publicaciones",
    "subscribeFor": "Suscribirse para",
    "joinGroup": "UNIRSE AL GRUPO",
    "membershipPending": "Membresía PENDIENTE",
    "viewMembershipAnswers": "Ver respuestas Membresía",
    "requested": "Solicitado",
    "dayFreeTrial": "días de prueba gratuita",
    "notPartOfGroup": "Tú aún no formas parte de este Grupo, tu Membresía Solicitudes está in Reseña. Una vez que un administrador haya aceptado tus solicitudes, te lo notificaremos",
    "pleaseAnswerMembershipQuestions": "Responde a las preguntas de Membresía para unirse a este Grupo",
    "answerQuestions": "Responder preguntas de membresía"
  },
  "userProfilePopover": {
    "active": "Activo",
    "longAgo": "hace mucho tiempo",
    "chatDisabled": "Este usuario ha deshabilitado su chat",
    "pointsToLevelUp": "puntos para subir de nivel",
    "profile": "Perfil",
    "deletedUser": "Usuario eliminado",
    "joined": "Unido",
    "contributions": "Contribuciones"
  },
  "courses": {
    "by": "Por",
    "free": "Gratis",
    "unknownInstructor": "Instructor Desconocido",
    "courseRestricted": "Esta Ruta está Privado",
    "courseDeleted": "Esta Ruta ha sido Eliminado",
    "noMatchingCourseFound": "No se ha encontrado ninguna Ruta coincidente",
    "addCourse": "Añadir curso",
    "updateCourse": "Actualizar el curso",
    "access": "Todos los miembros tienen acceso",
    "unableToAddCourse": "¡Vaya! No ha sido posible añadir el curso",
    "pleaseTryAgainLater": "Vuelva a intentarlo más tarde",
    "paymentIntegrationMissing": "¡Vaya! Falta la integración de pagos",
    "paymentIntegrationMissingMessage": "Integre los pagos en la ubicación para permitir los cursos de pago",
    "course": "Curso",
    "courseInThisGroup": "un curso existente en este grupo",
    "courseLinkCopied": "Enlace del curso copiado",
    "buyNow": "COMPRAR AHORA",
    "locked": "BLOQUEADO",
    "buyCourse": "COMPRAR CURSO",
    "open": "ABRIR",
    "moveCard": "Mover tarjeta",
    "courseViewMessage": "Debe formar parte de este grupo para ver los cursos.",
    "deleteCourse": "Eliminar el curso",
    "deleteCourseConfirmation": "¿Seguro que desea eliminar este curso?",
    "courseAccessNotGranted": "Acceso al curso no otorgado",
    "courseAccessNotGrantedMessage": "Actualmente, estamos trabajando para otorgarle acceso al curso. Actualice la página y vuelva a intentarlo en un momento.",
    "autoRenewsAfter": "Se renueva automáticamente después de",
    "oneTimePayment": "Pago único",
    "emptyCoursesMessage": "Parece un pueblo fantasma. No hay nada que ver aquí",
    "updatedSuccessfully": "Curso actualizado con éxito",
    "addedSuccessfully": "El curso se ha añadido correctamente",
    "createCourse": "Generar nueva Ruta",
    "emptyCourseLibrary": "¡Su biblioteca de rutas está vacía!",
    "createdOutsideGokollabMessage": "Esta comunidad se creó fuera de Gokollab y se hizo visible. Para Generar Nuevos Cursos, inicie sesión en la comunidad De su Fuente Canal",
    "createCourseOnGokollabMessage": "Generar un Nuevo Ruta en Gokollab para Crear Activado para los Miembros de su comunidad.",
    "or": "o",
    "createNewOne": "Generar uno Nuevo",
    "labels": {
      "selectCourse": "Seleccionar curso",
      "courseVisibility": "Visibilidad del curso",
      "courseAccess": "Acceso al curso",
      "coursePrice": "Precio del curso",
      "subscriptionType": "Tipo de suscripción",
      "billingPeriod": "Periodo de facturación",
      "testMode": "Modo de prueba",
      "turnOnTestPayments": "Activar los pagos de prueba utilizando una tarjeta de prueba",
      "currency": "Moneda",
      "trialDays": "Días de prueba",
      "recurring": "Recurrente",
      "free": "Gratis",
      "oneTime": "Una fecha",
      "refresh": "Actualizar",
      "accessStartsAtDay": "El Acceso empieza a las Día",
      "maximumYouCanEnterIs365": "Máx. Tú puedes introducir es 365",
      "allMembers": "cada Miembros",
      "levelUnlock": "Desbloqueo de Uniforme",
      "buyNow": "Comprar ahora",
      "timeUnlock": "Fecha Desbloquear",
      "gamificationLevel": "Ludificación Uniforme",
      "privateChannel": "Canal Privado",
      "private": "Privado",
      "marketingChannel": "Canal de Marketing",
      "selectCurrency": "Seleccionar moneda"
    },
    "placeholders": {
      "enterPrice": "Introducir precio",
      "enterTrialDays": "Indicar los días de prueba",
      "selectCurrency": "Seleccionar uno",
      "selectBillingPeriod": "Seleccionar uno",
      "billingPeriod": "Seleccionar periodo de facturación"
    },
    "validations": {
      "validPrice": "Introduzca un precio válido",
      "required": "Seleccione un curso",
      "validMembershipPrice": "Indique el precio de suscripción válido",
      "validTrialDays": "Introduzca unos días de prueba válidos",
      "requiredSubscriptionType": "Seleccione el tipo de suscripción",
      "courseVisibility": "Seleccionar curso Visibilidad",
      "requiredGamificationLevel": "Seleccionar Ludificación Uniforme",
      "requiredPrivateChannel": "Selecciona el canal Privado",
      "validAccessStartDay": "Por favor, introduce un Acceso start Día válido"
    },
    "descriptions": {
      "buyNowDescription": "Este curso es público en el momento de la compra",
      "timeUnlockDescription": "Miembros Unlock Después X días",
      "levelUnlockDescription": "Los miembros que solo tengan un determinado Uniforme podrán desbloquear",
      "allMembersDescription": "cada miembros tienen acceso a este curso",
      "privateChannelDescription": "Miembros de un canal privado",
      "privateDescription": "Acceso concedido solo por el administrador"
    },
    "helperText": {
      "levelBased": "Basado en niveles",
      "timeLimited": "hora-Limited",
      "privateBased": "Privado",
      "free": "Gratis",
      "levelAvailableAt": "Disponible en Uniforme 0{value}",
      "timeLimitedAfterJoining": "Público {value} {day} Después de unirse al Grupo",
      "day": "Día",
      "days": "días",
      "purchaseToUnlockAccess": "Comprar este curso para desbloquear Acceso",
      "privateCourse": "Curso privado - Acceso concedido solo por el administrador",
      "locked": "Este curso está bloqueado",
      "unlockAtLevel": "Este curso se desbloqueará en Uniforme {level}",
      "unlockAfterDays": "Este curso se desbloqueará Después {days} {dayText}",
      "privateChannelBased": "Privado basado en canales",
      "externalAccess": "Otro Grupo/Oferta"
    },
    "manageAccess": {
      "manageCourses": "Administrar Cursos",
      "revokeCourseAccess": "Gestionar cursos",
      "grantCoursesAccess": "Conceder cursos",
      "removeAccess": "Eliminar acceso",
      "grantAccess": "Conceda acceso",
      "grant": "Conceder",
      "clear": "Limpiar",
      "selectAll": "Seleccionar todo",
      "revokeAccessConfirmTitle": "¿Desea eliminar el acceso al curso?",
      "revokeAccessConfirmMessage": "¿Está seguro de que desea eliminar el acceso a «{courseName}» para {userName}?",
      "externalAccessTooltip": "No se puede eliminar: el usuario tiene acceso desde otro grupo u otra oferta",
      "cannotRevokeAutoAccess": "No se puede eliminar: el acceso se concede automáticamente según la configuración del curso (de pago, nivel, tiempo o gratuito)",
      "searchPlaceholder": "Busque cursos",
      "noCoursesFound": "No se han encontrado cursos",
      "noCoursesSelected": "No hay cursos seleccionados todavía",
      "noCoursesAvailable": "No hay cursos disponibles para conceder",
      "noSearchResults": "No hay resultados de búsqueda",
      "failedToLoadCourses": "No se han podido cargar los cursos",
      "accessRevoked": "El acceso al curso se ha eliminado correctamente",
      "failedToRevokeAccess": "Error al eliminar el acceso al curso",
      "accessGranted": "El acceso al curso se ha concedido correctamente",
      "multipleAccessGranted": "{count} cursos otorgados correctamente",
      "failedToGrantAccess": "No se pudo conceder acceso al curso"
    },
    "ariaLabels": {
      "courseCard": "Tarjeta del curso",
      "courseCardActions": "Acciones de la tarjeta del curso",
      "editCourse": "Editar curso",
      "deleteCourse": "Eliminar el curso",
      "moveCard": "Mover tarjeta",
      "copyLink": "Copiar enlace",
      "cardImage": "Imagen de tarjeta de curso"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Error al cargar el archivo"
    },
    "uploadLinkVideo": "Subir o enlazar un vídeo",
    "removeMedia": "Eliminar el contenido multimedia {fileName}"
  },
  "leaderboard": {
    "level": "Nivel",
    "lastUpdated": "Última actualización",
    "members": "Miembros",
    "percentOfMembers": "{percentage}% de los miembros",
    "rewards": "Recompensas",
    "allTime": "Histórico",
    "pointsToLevelUp": "puntos para subir de nivel",
    "points": "Puntos",
    "leaderboard7d": "Tabla de clasificación (7 días)",
    "leaderboard30d": "Tabla de clasificación (30 días)",
    "leaderboardAlltime": "Tabla de clasificación (histórico)",
    "yourRank": "Su posición",
    "noActivityToShow": "No hay actividad que mostrar",
    "rewardsWillBeDisplayedHere": "Las recompensas se mostrarán aquí",
    "seeAllLeaderboards": "Ver todas las clasificaciones",
    "addRewards": "Añadir recompensas",
    "howPointsWork": "Usted gana puntos cuando a otros miembros les gustan sus publicaciones o comentarios. 1 me gusta = 1 punto. Esto anima a los Usuarios a generar contenido de calidad e interactuar con otros miembros de su comunidad.",
    "levels": "Niveles",
    "levelsDescription": "A medida que gane puntos, subirá de nivel. Su nivel se muestra en la parte inferior derecha de su avatar. El número de puntos necesarios para pasar al siguiente nivel se muestra en la barra de progreso de la página de clasificación.",
    "pointsAndLevels": "Puntos y capas"
  },
  "events": {
    "createEvent": "Crear evento",
    "dragAndDrop": "Arrastrar y soltar un SVG, PNG o JPG (máximo 800 x 400 píxeles)",
    "editEvent": "Editar evento",
    "addEvent": "Añadir evento",
    "paymentDetails": "Información del pago",
    "event": "Evento",
    "goBack": "Volver atrás",
    "cancelEdit": "Cancelar la edición",
    "cancelEvent": "Cancelar evento",
    "next": "Siguiente",
    "saveEvent": "Guardar evento",
    "editRecurringEvent": "Editar evento recurrente",
    "thisEvent": "Este evento",
    "thisAndFollowingEvents": "Este y los siguientes eventos",
    "ok": "De acuerdo",
    "deleteRecurringEvent": "Eliminar evento recurrente",
    "allEvents": "Todos los eventos",
    "adminsFreeForPaidEvents": " * Los administradores pueden Registrarse en Pagado Eventos gratis",
    "deleteEvent": "Eliminar evento",
    "onceEventDeleted": "Una vez eliminado el evento, no se mostrará en su calendario.",
    "toRegister": "para registrarse",
    "calendar": "Calendario",
    "addToCalendar": "Añadir al calendario",
    "declineRegistration": "Rechazar",
    "paymentFailedMessage": "Su pago ha fallado debido a algunas circunstancias imprevistas. Inténtelo de nuevo más tarde.",
    "upcoming": "Próximo",
    "noMoreEvents": "No hay más eventos que mostrar",
    "joinGroupToRegister": "Debe formar parte de este grupo para registrarse en este evento",
    "past": "Anterior",
    "youHaveRegisteredForOneEvent": "Se ha inscrito en un evento. Le enviaremos un recordatorio un día antes de cada evento.",
    "upcomingEvents": "Próximos eventos",
    "noUpcomingEvents": "No hay próximos eventos",
    "pastEvents": "Eventos pasados",
    "noPastEvents": "No hay eventos pasados",
    "noMatchingEventFound": "No se ha encontrado ningún evento coincidente",
    "recordings": "Grabaciones",
    "week": "Semana",
    "month": "Mes",
    "today": "Hoy",
    "registrationConfirmed": "Registro confirmado para {event}.",
    "eventDeletedOrRestricted": "El Evento ha sido Eliminado O Privado.",
    "eventDeleted": "El evento ha sido eliminado",
    "eventRestricted": "No tiene acceso a este evento",
    "validations": {
      "titleValidation": "El título es obligatorio",
      "colorValidation": "El color es obligatorio",
      "startTimeValidation": "La hora de inicio es obligatoria",
      "endTimeValidation": "La hora de finalización es obligatoria",
      "endTimeAfterStartTime": "La hora de finalización debe ser posterior a la de inicio",
      "startTimeMustBeInFuture": "La hora de inicio debe ser futura",
      "locationValidation": "La ubicación es obligatoria",
      "locationValidationMobile": "La ubicación es obligatoria",
      "locationUrlValidation": "Se necesita una URL de ubicación válida",
      "descriptionValidation": "La descripción es obligatoria",
      "descriptionValidationMaxLength": "La descripción no puede superar los 300 caracteres",
      "recaptchaError": "La verificación ha fallado. Inténtelo de nuevo",
      "repeatIntervalValidation": "La frecuencia es obligatoria",
      "repeatIntervalValidator": "El intervalo de repetición debe ser un día, una semana, un mes o un año",
      "repeatIntervalRequired": "El intervalo de repetición es obligatorio",
      "repeatOccurrenceValidator": "La frecuencia de repetición debe ser mayor que 0",
      "repeatOccurrenceRequired": "La frecuencia de repetición es obligatoria",
      "invalidDateFormat": "Formato de fecha no válido",
      "endDateMustBeAfterStartDate": "La fecha de finalización debe ser posterior a la fecha de inicio del evento",
      "recurringEndDateValidation": "La fecha de finalización de la recurrencia es obligatoria",
      "repeatsOnValidation": "Seleccione al menos un día",
      "invalidDaySelection": "Selección de día no válida",
      "endOptionRequired": "La opción de finalización es obligatoria",
      "levelValidation": "Seleccione un nivel",
      "courseValidation": "Seleccione un curso",
      "channelValidation": "Seleccione un canal",
      "eventPriceValidation": "El precio es obligatorio y debe ser mayor que {min}"
    },
    "placeholders": {
      "selectStartTime": "Seleccionar hora de inicio",
      "selectEndTime": "Seleccionar la hora de finalización",
      "selectLocation": "Seleccionar la ubicación",
      "locationUrl": "Enlace/Dirección",
      "description": "Descripción",
      "selectRecurringEndDate": "Seleccionar la fecha final de la recurrencia",
      "selectDate": "Seleccionar fecha",
      "event": "Evento",
      "selectColor": "Seleccione un color",
      "selectAttendees": "Seleccionar asistentes",
      "selectPrivateChannel": "Seleccionar un canal privado",
      "selectCourse": "Seleccionar curso",
      "selectLevels": "Seleccionar los niveles",
      "selectCalendar": "Seleccionar calendario"
    },
    "labels": {
      "startTime": "Hora de inicio",
      "endTime": "Hora de finalización",
      "others": "Otros",
      "oneTimePriceForEventRegistration": "precio único de inscripción al evento.",
      "totalAmount": "Importe total",
      "cardAuthorizationText": "Al facilitar los datos de su tarjeta, autoriza a {locationName} a cargar en su tarjeta los pagos futuros de acuerdo con sus condiciones.",
      "secureAndSafePayments": "Pagos 100 % seguros y protegidos",
      "day": "Día",
      "week": "Semana",
      "month": "Mes",
      "year": "Año",
      "recurringEvent": "¿El evento será un evento recurrente?",
      "repeatsEvery": "Se repite cada",
      "repeatsOn": "Se repite en",
      "end": "Final",
      "ends": "Final",
      "neverEnds": "No termina nunca",
      "orange": "Naranja",
      "red": "Rojo",
      "blue": "Azul",
      "green": "Verde",
      "violet": "Violeta",
      "purple": "Morado",
      "yellow": "Amarillo",
      "title": "Título",
      "color": "Color",
      "allMembers": "Todos los miembros",
      "membersAtALevel": "Miembros a un nivel",
      "membersOfACourse": "Miembros de un curso",
      "membersOfAPrivateChannel": "Miembros de un canal privado",
      "whoCanAttendTheEvent": "¿Quién puede asistir al evento?",
      "channel": "Canal",
      "course": "Curso",
      "level": "Nivel",
      "remindAttendeesByEmail": "Recordar a los asistentes Vía Correo electrónico 1 Día Antes",
      "hideLocationFromNonAttendees": "Ocultar la ubicación de los no asistentes.",
      "addChargesToTheEvent": "Añadir facturación al Evento",
      "noPaymentRequired": "Ningún pago Obligatorio",
      "location": "Ubicación",
      "link": "Enlace",
      "description": "Descripción",
      "timezone": "Zona horaria",
      "eventType": "Tipo de evento",
      "eventTypeChangeWarning": "Dinámico al Tipo de evento O se aplicará a cada sucesos/incidentes/repeticiones in la serie.",
      "never": "Nunca",
      "on": "Activado",
      "after": "Después",
      "occurrences": "sucesos/incidentes/repeticiones",
      "selectEventEnd": "Seleccionar cuando el evento será final.",
      "turnOnTestPayments": "Girar Activado Prueba pagos Vía a Prueba tarjeta",
      "pay": "Pagar",
      "hideAttendees": "Ocultar los asistentes De Grupo Miembros",
      "guests": "{count} invitados",
      "guestList": "Lista de Invitado",
      "noAttendees": "Todavía no hay asistentes",
      "viewAttendees": "Ver los asistentes",
      "exportAttendees": "Exportar asistentes"
    },
    "notifications": {
      "eventCreated": "¡Evento creado con éxito!",
      "pickImageFailed": "No se ha podido seleccionar la imagen",
      "pickImageFailedContent": "Se ha producido un error al seleccionar la imagen.",
      "eventUpdated": "¡Evento actualizado con éxito!",
      "eventCreationFailed": "¡Error en la creación del Evento !",
      "eventUpdateFailed": "¡La actualización del Evento ha fallado!",
      "EVENT_CREATE_INVALID_TIME_RANGE": "La hora de inicio debe ser anterior a la hora de finalización.",
      "EVENT_CREATE_PAST_TIME_NOT_ALLOWED": "La hora de inicio debe ser futura.",
      "EVENT_CREATE_DURATION_EXCEEDED": "La duración del evento excede el límite máximo permitido.",
      "EVENT_CREATE_FAILED": "No se ha podido crear el evento. Inténtelo de nuevo.",
      "EVENT_UPDATE_NOT_FOUND": "No se ha podido actualizar el evento porque no ha sido posible encontrarlo.",
      "EVENT_UPDATE_UNAUTHORIZED": "No tiene permiso para actualizar este evento.",
      "EVENT_UPDATE_INVALID_OPERATION": "Esta acción de actualización del evento no está permitida.",
      "eventDeleted": "¡El evento se ha eliminado correctamente!",
      "eventDeletionFailed": "La eliminación del evento ha fallado.",
      "paymentFailed": "El pago ha fallado.",
      "registrationSuccessful": "El registro se ha completado correctamente.",
      "registrationFailed": "El registro ha fallado.",
      "addToCalendarFailed": "No se ha podido añadir el evento al calendario.",
      "locationDetailsCopied": "¡Detalles de ubicación copiados al portapapeles!",
      "registrationDeclined": "El registro se ha rechazado correctamente.",
      "registrationDeclinedFailed": "El rechazo del registro ha fallado.",
      "fetchAttendeesFailed": "Error al cargar los asistentes",
      "emailCopied": "Correo electrónico Copiado al portapapeles",
      "exportAttendeesFailed": "Error al exportar asistentes"
    },
    "selectCalendar": "Seleccionar calendario",
    "eventImage": "Imagen del evento",
    "errorLoadingEvent": "Error al cargar el evento"
  },
  "login": {
    "invite": "le ha invitado a unirse a"
  },
  "contentReports": {
    "contentDeleted": "El contenido se ha eliminado.",
    "noActionTaken": "No se ha tomado ninguna medida sobre el contenido denunciado.",
    "reportedContentNotFound": "No se ha encontrado el contenido denunciado. Es posible que ya se hayan tomado medidas al respecto.",
    "reported": "Denunciado",
    "viewAllReportedContentHere": "Puede ver todo el contenido multimedia denunciado aquí",
    "takeActionOnReportedContent": "Actuar sobre el contenido denunciado",
    "andOthers": "y {count} otros",
    "reportedThisPost": "ha denunciado esta publicación",
    "keep": "MANTENER",
    "remove": "ELIMINAR",
    "deleteContent": "Eliminar el contenido",
    "deleteConfirmation": "¿Seguro que desea eliminar este contenido?",
    "noMemberReportedContent": "Ningún contenido notificado por los miembros",
    "whenMembersReportPostsOrComments": "Cuando los miembros denuncien publicaciones o comentarios, aparecerán aquí para que los revise. Podrá conservarlos o borrarlos, así como suspender, eliminar o bloquear a los miembros que los hayan publicado.",
    "reportedThisComment": "Ha denunciado este comentario"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Este contenido no está disponible en este momento",
    "whenThisHappens": "Cuando esto ocurre, suele ser porque el propietario solo lo compartió con un pequeño grupo de personas o modificó quién puede verlo o ha sido borrado"
  },
  "search": {
    "noResultsFor": "0 resultados para \"{query}\" en la comunidad",
    "noResultsFound": "No se han encontrado resultados"
  },
  "noCommunities": {
    "noCommunitiesFound": "No se han encontrado comunidades",
    "startCreatingYourOwnCommunities": "Empiece a crear sus propias comunidades y comprométase con su público.",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "No se ha unido a",
      "communities": "Comunidades",
      "yet": "Aún"
    },
    "noCommunitiesFoundGokollabDescription": "Descubra espacios donde las personas comparten ideas, se apoyan mutuamente y crecen juntas."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "No se ha inscrito en ningún",
      "course": "Curso",
      "yet": "Aún"
    },
    "noCoursesFoundGokollabDescription": "Descubra cursos de alto impacto diseñados para ayudarle a aprender, mejorar y tener éxito."
  },
  "notFound": {
    "ohNo": "oh, no…",
    "weHaveHadAnError": "Se ha producido un error",
    "error404": "Error 404",
    "sorryPleaseCheckBack": "Lo sentimos… Vuelva a comprobarlo en un momento."
  },
  "time": {
    "justNow": "Justo ahora",
    "timeAgo": "Hace {value}{unit}",
    "timeAgoFull": "Hace {value} {unit}",
    "units": {
      "year": "a",
      "years": "años",
      "month": "m",
      "months": "meses",
      "week": "sem",
      "weeks": "semanas",
      "day": "d",
      "days": "días",
      "hour": "h",
      "hours": "horas",
      "minute": "m",
      "minutes": "minutos",
      "second": "s",
      "seconds": "Segundos",
      "monthly": "Mensual",
      "weekly": "Semanal",
      "annually": "Anualmente"
    },
    "dayAbbreviations": {
      "mon": "Lun.",
      "tue": "Mar.",
      "wed": "Mié.",
      "thu": "Jue.",
      "fri": "Vie.",
      "sat": "Sáb.",
      "sun": "Dom."
    }
  },
  "emojiPicker": {
    "notfound": "No se han encontrado emojis",
    "recent": "Usado con frecuencia",
    "smileys": "Emoticonos y emoticonos",
    "people": "Personas y Cuerpo",
    "nature": "Animales y naturaleza",
    "foods": "Comida y bebida",
    "activity": "Actividad",
    "places": "Viajes y plazas",
    "objects": "Objetos",
    "symbols": "Símbolos",
    "flags": "Marcadores",
    "custom": "Personalizado"
  },
  "topNavBarHeaderText": {
    "discussion": "Debate",
    "learning": "aprendizaje",
    "people": "Personas"
  },
  "globalUserProfile": {
    "ownedBy": "Propiedad de {name}",
    "memberships": "Suscripciones",
    "membershipsInCommon": "Suscripciones ({count} en común)",
    "membersCount": "{count} miembros",
    "contributions": "{count} contribuciones a {group}",
    "contributionsFor": "Contribuciones para",
    "justPosts": "Solo publicaciones",
    "postAndComments": "Publicación y comentarios",
    "followSuccess": "Usted ha comenzado a seguir",
    "unfollowSuccess": "Tú ya no estás siguiendo"
  },
  "profile": {
    "active": "Activos",
    "ago": "hace",
    "bio": "Biografía"
  },
  "golive": {
    "golive": "Sala en directo",
    "defaultEventTitle": "Evento en vivo de la Comunidad",
    "meetingCreationFailed": "No se pudo crear la reunión de GoLive. Inténtelo de nuevo.",
    "selectVideoSourceToStart": "Hacer clic en una fuente de vídeo para iniciar la transmisión",
    "chooseHowToGoLive": "Elija cómo quiere transmitir en directo",
    "flipCamera": "Girar cámara",
    "participants": "Participantes",
    "chats": "Chats",
    "react": "Reaccionar",
    "raise": "Aumentar",
    "shareScreen": "Compartir",
    "letsCheckYourCamAndMic": "Vamos a comprobar su cámara y micrófono",
    "hostedBy": "Alojado por",
    "join": "Unirse",
    "needCameraPermission": "Necesita permiso de cámara",
    "needMicrophonePermission": "Necesita permiso de micrófono",
    "needSpeakerPermission": "Necesita permiso de altavoz",
    "createLiveVideo": "Crear un vídeo en directo",
    "host": "Servidor",
    "chooseWhereToPost": "Elija dónde publicar",
    "whenAreYouGoingLive": "¿Cuándo va a estar en directo?",
    "postingIn": "publicando en",
    "live": "En tiempo real",
    "postDetails": "Detalles de la publicación",
    "streamingSoftware": "Aplicaciones de transmisión",
    "streamingSoftwareDescription": "Puede utilizar un software de transmisión como Zoom, OBS o StreamYard para transmitir directamente. Solo tiene que copiar la URL y la clave de transmisión proporcionadas en la configuración de su software de transmisión. Una vez configurado, inicie su emisión en el software y se transmitirá en directo automáticamente a la plataforma seleccionada.",
    "streamKey": "Clave de transmisión",
    "streamKeyDescription": "Esto se puede reutilizar cada vez que transmite en directo. Solo puede emitir un vídeo en directo a la vez con su clave de streaming persistente.",
    "serverUrl": "URL del Servidor",
    "serverUrlDescription": "Esto puede aparecer como «URL» o «Dirección» en su software de transmisión.",
    "selectVideoSource": "Seleccione la fuente de vídeo",
    "copyPasteStreamKey": "Copie y pegue la clave de transmisión en su software de transmisión.",
    "copyPasteServerUrl": "Copie y pegue la URL del servidor en su software de transmisión.",
    "addPostDetails": "Añadir detalles de la publicación",
    "enterTitle": "Introduzca un título",
    "notifyMembers": "Notifique a los miembros que va a entrar en directo (solo se envían notificaciones en la aplicación y notificaciones automáticas)",
    "notifyMembersMobile": "Notifique a los miembros que va a empezar la retransmisión en directo",
    "meetingRoom": "Sala de reuniones",
    "meetingRoomDescription": "Utilice la función «Salas de reuniones» para organizar sesiones en directo en las que todos los participantes puedan encender sus cámaras web, activar el micrófono e interactuar en tiempo real. Esto crea una experiencia de sala virtual similar a Zoom o Google Meet, lo que permite a todos verse y hablar entre ustedes cara a cara.",
    "cameraControls": "Controles de la cámara",
    "cameraControlsTooltip": "Configure los ajustes de la cámara y el audio antes de empezar la retransmisión en directo. Asegúrese de que su cámara y micrófono estén correctamente conectados y tengan los permisos necesarios.",
    "selectMediaSource": "Seleccionar una fuente de contenido multimedia",
    "startScreenShare": "Iniciar la pantalla compartida",
    "stopScreenShare": "Detener la pantalla compartida",
    "wasLive": "ha estado en directo",
    "isLive": "está en directo",
    "goingLive": "va a estar en directo",
    "tapToAddDescription": "Pulse para incluir una descripción...",
    "selectChannel": "Seleccionar el canal",
    "saveAsPost": "Mantenga la transmisión en directo como publicación",
    "selectVideoSourceTooltip": "Puede elegir entre software de transmisión o cámara web cuando vaya a retransmitir en directo:\n\n1. Software de retransmisión\n • Le proporcionaremos una clave y una URL de retransmisión.\n   • Debe configurarlos en Zoom, OBS o cualquier otro software de terceros que admita la transmisión en directo.\n\n2. Cámara web\n   • Transmita en directo directamente con su cámara y micrófono.\n   • Los participantes pueden ver la transmisión en directo e interactuar a través del chat en tiempo real.\n   • Como anfitrión, puede controlar y revocar el acceso a la cámara o al micrófono en cualquier momento.",
    "pleaseSelectCameraMicrophoneSpeaker": "Haga clic en la cámara, el micrófono y el altavoz",
    "pleaseStartStreamBeforeGoingLive": "Inicie la transmisión antes de entrar en directo",
    "watching": "Observando",
    "processingRecording": "Procesando la grabación",
    "recordingFailed": "Grabación no disponible",
    "recordingFailedDescription": "Nos encontramos con un problema al procesar esta sesión en directo, y no se pudo guardar la grabación",
    "streamEndedRecordingWillBeAvailableSoon": "La transmisión ha finalizado. La grabación está siendo procesada y estará disponible en breve.",
    "joinStream": "Unirse a la transmisión",
    "recordingInProgress": "Grabación en progreso",
    "recordingNotAvailable": "Grabación fallida",
    "leaveSession": "Salir de Sesión",
    "endSession": "Terminar sesión",
    "rec": "REC",
    "selectCamera": "Seleccionar cámara",
    "noCamerasFound": "No se han encontrado cámaras",
    "cameraPermissionNeeded": "Se necesita permiso para usar la cámara",
    "leave": "Salir",
    "chooseMicCam": "Seleccione el micrófono y la cámara",
    "selectMicrophone": "Seleccionar micrófono",
    "selectSpeaker": "Seleccionar altavoz",
    "noMicrophonesFound": "No se han encontrado micrófonos",
    "noSpeakersFound": "No se han encontrado altavoces",
    "microphonePermissionNeeded": "Se necesita permiso para usar el micrófono",
    "speakerPermissionNeeded": "Se necesita permiso para usar el altavoz",
    "noParticipantOpenCamOrMic": "Esta reunión no se ha grabado, ya que ningún participante ha activado su micrófono o cámara. Las grabaciones solo se crean cuando al menos un participante interactúa."
  }
}
